module.exports = __webpack_public_path__ + "img/10.bec0b423.jpg";